import { render, staticRenderFns } from "./FloatingBtn.vue?vue&type=template&id=52a14b6e&scoped=true&"
import script from "./FloatingBtn.vue?vue&type=script&lang=js&"
export * from "./FloatingBtn.vue?vue&type=script&lang=js&"
import style0 from "./FloatingBtn.vue?vue&type=style&index=0&id=52a14b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a14b6e",
  null
  
)

export default component.exports